<template>
  <div>
    <h1>Home</h1>
    <h2>Welcome</h2>
    <div class="homeContent">
      <p>
        This is a web application for organizing and tracking members of an
        organiztion. And tracking groups those members can be or are a part of.
        In this case connection groups.
      </p>
      <p>
        You must create an account and log in, in order to see the existing
        connection groups
      </p>
      <p>
        Members and groups are not coupled to an existing user ID. Although that
        could be remedied.
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    
  }
</script>

<style scoped>
.homeContent {
  text-align: left;
  line-height: 1.2rem;
}
</style>
